import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'



export default class GettingStarted extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }



render() {
  return (
  <div>

      <div className="Logo">
        <a className="Img-Link" href="#"><Link className="home-link" to='/'><img src={logo} className="App-logo" alt="logo" /></Link></a>
        <a className="Developer-link" href="#"><Link className="home-link" to='/'>Developer</Link></a>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>

        {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
        {isAuthenticated() ? (<Link className="right" to='' onClick={() => this.logout()}>Log out</Link>) : ''}
            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>


      <div className="App-banner">

        <a className="newforma-world-link" href="http://www.newformaworld.com/index.php"> Newforma World</a> 2018 | October 2 - 5, 2018 | Connecting People, Projects and Information

      </div>

      <div className="main-content">
        <p className="p-oops">Oops you are not logged in and cannot access the requested page. Click here to Log In</p>
        <div><a className="create-btn-oops"><SignIn/></a></div>

      </div>

</div>)}}



/** WEBPACK FOOTER **
 ** ./src/pages/SignInRedirect/index.js
 **/